import _toConsumableArray from "/var/lib/jenkins/workspace/minasidor.nsva.se/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/var/lib/jenkins/workspace/minasidor.nsva.se/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
import { treeMenuContext } from "@whitespace/components/src/contexts";
import { useSet } from "@whitespace/components/src/hooks";
import clsx from "clsx";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { filterAttributes } from "../utils";
import * as defaultStyles from "./TreeMenu.module.css";
import TreeMenuList from "./TreeMenuList";
function encodePath(path) {
  return path && JSON.stringify(path);
}
function decodePath(path) {
  return path && JSON.parse(path);
}
function documentPositionComparator(a, b) {
  if (a === b) {
    return 0;
  }
  var position = a.compareDocumentPosition(b);
  if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
    return -1;
  } else if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) {
    return 1;
  } else {
    return 0;
  }
}
export default function TreeMenu(_a) {
  var _b = _a,
    _b$styles = _b.styles,
    styles = _b$styles === void 0 ? defaultStyles : _b$styles,
    className = _b.className,
    items = _b.items,
    location = _b.location,
    restProps = __objRest(_b, ["styles", "className", "items", "location"]);
  var _useSet = useSet([], function (a, b) {
      return encodePath(a) === encodePath(b);
    }),
    _useSet2 = _slicedToArray(_useSet, 2),
    expandedItems = _useSet2[0],
    _useSet2$ = _useSet2[1],
    toggleExpandedItem = _useSet2$.toggle,
    isItemExpanded = _useSet2$.has,
    expandItem = _useSet2$.add,
    collapseItem = _useSet2$.delete;
  var itemsRef = useRef({});
  var focusDummyRef = useRef();
  var _useState = useState(encodePath([0])),
    _useState2 = _slicedToArray(_useState, 2),
    encodedFocusedPath = _useState2[0],
    setEncodedFocusedPath = _useState2[1];
  var focusedPath = decodePath(encodedFocusedPath);
  var setFocusedPath = useCallback(function (path) {
    setEncodedFocusedPath(encodePath(path.map(function (index, pos) {
      return index >= 0 ? index : getItemByPath(path.slice(0, pos + 1)).children.length + index;
    })));
  }, []);
  var isFocusedPath = useCallback(function (path) {
    return encodePath(path) === encodePath(focusedPath);
  }, [focusedPath]);
  var getAllItemPaths = useCallback(function (items2) {
    var parentPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return items2.reduce(function (acc, item, index) {
      var path = [].concat(_toConsumableArray(parentPath), [index]);
      acc.push({
        path: path,
        url: item.url
      });
      if (item.children) {
        acc.push.apply(acc, _toConsumableArray(getAllItemPaths(item.children, path)));
      }
      return acc;
    }, []);
  }, [items]);
  var getItemByPath = useCallback(function (path) {
    return path.reduce(function (item, index) {
      var _a2, _b2;
      return (_b2 = item == null ? void 0 : item.children) == null ? void 0 : _b2[index >= 0 ? index : ((_a2 = item == null ? void 0 : item.children) == null ? void 0 : _a2.length) + index];
    }, {
      children: items
    });
  }, [items]);
  var isCurrentItem = useCallback(function (item) {
    return item.url && item.url === location.pathname;
  }, [location.pathname]);
  var itemPaths = useMemo(function () {
    return getAllItemPaths(items);
  }, [items]);
  var findItemPath = useCallback(function (condition) {
    var _a2;
    return ((_a2 = itemPaths.find(condition)) == null ? void 0 : _a2.path) || null;
  }, [items]);
  var currentItemPath = useMemo(function () {
    return findItemPath(isCurrentItem);
  }, [isCurrentItem, findItemPath]);
  useEffect(function () {
    expandedItems.forEach(function (item) {
      return collapseItem(item);
    });
    (currentItemPath || []).reduce(function (path, index) {
      path = [].concat(_toConsumableArray(path), [index]);
      expandItem(path);
      return path;
    }, []);
  }, [encodePath(currentItemPath)]);
  var registerItemElement = useCallback(function (path, element) {
    var _a2, _b2, _c;
    if (element == null) {
      var prevElement = (_a2 = itemsRef.current) == null ? void 0 : _a2[encodePath(path)];
      if (prevElement === document.activeElement) {
        (_b2 = focusDummyRef.current) == null ? void 0 : _b2.focus();
      }
      (_c = itemsRef.current) == null ? true : delete _c[encodePath(path)];
    } else {
      itemsRef.current[encodePath(path)] = element;
      updateFocus();
    }
  }, []);
  var ref = useRef();
  var updateFocus = useCallback(function () {
    var element = itemsRef.current[encodedFocusedPath];
    if (element && document.activeElement !== element && ref.current && ref.current.contains(document.activeElement)) {
      element.focus();
    }
  }, [encodedFocusedPath]);
  useEffect(function () {
    updateFocus();
  }, [updateFocus]);
  var handleDownKey = useCallback(function () {
    var focusedElement = itemsRef.current[encodedFocusedPath];
    var focusableElements = Object.values(itemsRef.current);
    focusableElements.sort(documentPositionComparator);
    var index = focusableElements.indexOf(focusedElement) + 1;
    var nextElement = focusableElements[index % focusableElements.length];
    var key = Object.keys(itemsRef.current).find(function (key2) {
      return itemsRef.current[key2] === nextElement;
    });
    setEncodedFocusedPath(key);
  }, [encodedFocusedPath]);
  var handleUpKey = useCallback(function () {
    var focusedElement = itemsRef.current[encodedFocusedPath];
    var focusableElements = Object.values(itemsRef.current);
    focusableElements.sort(documentPositionComparator);
    var index = focusableElements.indexOf(focusedElement) - 1;
    var prevElement = focusableElements[(focusableElements.length + index) % focusableElements.length];
    var key = Object.keys(itemsRef.current).find(function (key2) {
      return itemsRef.current[key2] === prevElement;
    });
    setEncodedFocusedPath(key);
  }, [encodedFocusedPath]);
  var handleRightKey = useCallback(function () {
    if (!isItemExpanded(focusedPath)) {
      expandItem(focusedPath);
    } else {
      var firstChildPath = [].concat(_toConsumableArray(focusedPath), [0]);
      var firstChildItem = getItemByPath(firstChildPath);
      if (firstChildItem) {
        setFocusedPath(firstChildPath);
      }
    }
  }, [encodedFocusedPath, focusedPath]);
  var handleLeftKey = useCallback(function () {
    if (isItemExpanded(focusedPath)) {
      collapseItem(focusedPath);
    } else {
      var parentPath = focusedPath.slice(0, -1);
      if (parentPath.length > 0) {
        setFocusedPath(parentPath);
      }
    }
  }, [focusedPath]);
  var handleSpaceKey = useCallback(function () {
    toggleExpandedItem(focusedPath);
  }, [focusedPath]);
  var handleEndKey = useCallback(function () {
    var focusableElements = Object.values(itemsRef.current);
    focusableElements.sort(documentPositionComparator);
    var lastElement = focusableElements[focusableElements.length - 1];
    var key = Object.keys(itemsRef.current).find(function (key2) {
      return itemsRef.current[key2] === lastElement;
    });
    setEncodedFocusedPath(key);
  }, [encodedFocusedPath]);
  var handleHomeKey = useCallback(function () {
    var focusableElements = Object.values(itemsRef.current);
    focusableElements.sort(documentPositionComparator);
    var firstElement = focusableElements[0];
    var key = Object.keys(itemsRef.current).find(function (key2) {
      return itemsRef.current[key2] === firstElement;
    });
    setEncodedFocusedPath(key);
  }, [encodedFocusedPath]);
  var treeMenuContextValue = {
    expandedItems: expandedItems,
    isCurrentItem: isCurrentItem,
    isFocusedPath: isFocusedPath,
    isItemExpanded: isItemExpanded,
    registerItemElement: registerItemElement,
    setFocusedPath: setFocusedPath,
    styles: styles,
    toggleExpandedItem: toggleExpandedItem
  };
  var attributes = filterAttributes(restProps);
  return /* @__PURE__ */React.createElement(treeMenuContext.Provider, {
    value: treeMenuContextValue
  }, /* @__PURE__ */React.createElement("nav", __spreadProps(__spreadValues({
    className: clsx(className, styles.component)
  }, attributes), {
    ref: ref,
    onFocus: function onFocus() {
      updateFocus();
    },
    onKeyDown: function onKeyDown(event) {
      switch (event.key) {
        case "Down":
        case "ArrowDown":
          event.preventDefault();
          event.stopPropagation();
          return handleDownKey(event);
        case "Up":
        case "ArrowUp":
          event.preventDefault();
          event.stopPropagation();
          return handleUpKey(event);
        case "Right":
        case "ArrowRight":
          event.preventDefault();
          event.stopPropagation();
          return handleRightKey(event);
        case "Left":
        case "ArrowLeft":
          event.preventDefault();
          event.stopPropagation();
          return handleLeftKey(event);
        case "End":
          event.preventDefault();
          event.stopPropagation();
          return handleEndKey(event);
        case "Home":
          event.preventDefault();
          event.stopPropagation();
          return handleHomeKey(event);
        case " ":
          event.preventDefault();
          event.stopPropagation();
          return handleSpaceKey(event);
      }
    }
  }), /* @__PURE__ */React.createElement("span", {
    tabIndex: -1,
    ref: focusDummyRef
  }), /* @__PURE__ */React.createElement(TreeMenuList, {
    items: items
  })));
}